import React from 'react';
import { useSelector } from "react-redux";
import styled from 'styled-components';

import QuantitySelector from "./QuantitySelector/QuantitySelector";
import AddToCartButton from "./AddToCartButton";

const AdToCartWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    flex-direction: row;
    align-items: flex-end;
    margin-bottom: 15px;

    button {
      margin-bottom: 0;
    }
  }
`;

const AddToCartSection = ({
  lfcMode,
  isPanel,
  messages,
  configQuantity,
  updateConfigQuantity,
  sendToJeeves,
  context,
  imageBaseUrl,
  erpItemNumber,
  channelId,
  loop54EventBaseUrl,
  productId,
  configResult,
  articles,
  getApiBaseUrl,
}) => {
  const { colorPickerVisible, colorUnique } = useSelector((state) => state.color);
  
  return (
  <AdToCartWrapper>
    {(lfcMode === "WDW" || lfcMode === "DOOR") && !isPanel && (
      <QuantitySelector
        labelText={messages.amount}
        quantity={configQuantity}
        onChange={updateConfigQuantity}
      />
    )}

    {isPanel
      ? <button
        className="lfc-send-to-jeeves-button"
        onClick={sendToJeeves}
        disabled={colorPickerVisible && !colorUnique}
      >
        {"Add to order row"}
      </button>
      : <AddToCartButton
        addToCartLabel={messages.addToCart}
        context={context}
        imageBaseUrl={imageBaseUrl}
        lfcMode={lfcMode}
        erpItemNumber={erpItemNumber}
        channelId={channelId}
        loop54EventBaseUrl={loop54EventBaseUrl}
        productId={productId}
        configResult={configResult}
        configQuantity={configQuantity}
        articles={articles}
        cvyAddedToCartResponse={messages.cvyAddedToCartResponse}
        getApiBaseUrl={getApiBaseUrl}
      />
    }
  </AdToCartWrapper>
)};

export default AddToCartSection;